module.exports = __webpack_public_path__ + "img/lab-empty-state.2c87ee42.png";